import React,{ useState } from 'react';
import { Link } from 'react-router-dom';
import { GoPlus } from 'react-icons/go';
import { FaPlay } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss';
import { Modal, Button } from 'react-bootstrap'

const ProjectItem = ({ project_img_num, project_subtitle, project_title, linkk,vIds }) => {
   const [open, setOpen] = useState(false);   
   const setVid = () => {      
      setOpen(true)
   }
   return (
      <>
      {open && (
            <Modal show={open} style={{background: "transparent"}} >
               <ModalVideo channel='youtube' autoplay isOpen={open} videoId={vIds} onClose={() => setOpen(false)} />                 
          </Modal>
         )}
         <div className="col-lg-4 col-md-6">
            <div className="tp-project z-index mb-30">
               <div className="tp-project-img">
                  <img src={`assets/img/project/winner/stalwart${project_img_num}`} className="img-fluid" alt="img not found" />
               </div>
               <div className="tp-testimonial-two-qoute " style={{background:"#ea1c1ced", borderRadius:"10px", top:"40%", left:"40%", cursor:"pointer"}} onClick={() => setVid(true)} >
                  <i ><FaPlay /></i>
               </div>
               <div className="tp-project-text" style={{justifyContent:"center"}}>
                  <div className="tp-project-text-content">                     
                     <h4 className="tp-project-title text-center">{project_subtitle}</h4>
                     <span className="tp-project-subtitle text-center">{project_title}</span>
                  </div>
                  {/* <div className="tp-project-text-icon">
                     <Link to="/projectsDetails"><i className="text-white"><GoPlus /></i></Link>
                  </div> */}
               </div>
            </div>
         </div>
      </>
   );
};

export default ProjectItem;